import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';


export class UsercommonfunctionsApi extends SystemBaseApi {

    public get ControllerName(): any {
        return 'usercommonfunctions'
    }
    /**
     * 批量保存用户常用功能
     * @param params 
     */
   public savesFunctions(params){
    return this.send(params,"savesFunctions",Methods.POST)
   }
   /**
    * 用户id查询列表
    * @param userId 
    * @returns 
    */
   public getListByUserId(userId){
    return this.send({userId:userId},"getListByUserId",Methods.GET)
   }
}
